/** @format */

import React from 'react';
import CardBoxImage from './CardBoxImage';
import CardBoxDescription from './CardBoxDescription';
import CardBoxTitle from './CardBoxTitle';
import TemplateButton from '../../Buttons/TemplateButton';
import CustomTextButtom from '../../Buttons/CustomTextButton';
import CardBoxAction from './CardBoxAction';

interface CardBoxInterface {
    classes: any;
    title: string;
    description?: string;
    img?: string;
    actionCallback?: () => void;
}

const CardBox = (props: CardBoxInterface): React.ReactElement => {
    const { classes } = props;
    return (
        <div className={classes.cardBox}>
            {props.img && (
                <div>
                    <CardBoxImage img={props.img} />
                </div>
            )}
            <div className={classes.cardBoxContentPadding}>
                <CardBoxTitle classes={classes} title={props.title} />
                {props.description && <CardBoxDescription classes={classes} description={props.description} />}
                {props.actionCallback && <CardBoxAction classes={classes} actionCallback={props.actionCallback} />}
            </div>
        </div>
    );
};

export default CardBox;
